<template lang='pug'>
  .home-integrations
    h2 Çözüm Ortaklarımız
    h3 SekuriTik ürünü gelişimi sırasında kullanılan teknolojiler
    .home-integrations-radar
      .circle(v-for='idx of [1,2,3,4,5]')
      .bubble.bubble-one
        img(:src='(`https://res.cloudinary.com/sekuritim/image/upload/v1575922730/WifiFastSpot/sekuritim_scaled.png`)', alt='Sekuritim')
      .bubble.bubble-two
        img(:src='(`https://res.cloudinary.com/sekuritim/image/upload/v1575967369/WifiFastSpot/mikrotik-bar.png`)', alt='MikroTik')
      .bubble.bubble-three
        img(:src='(`https://res.cloudinary.com/sekuritim/image/upload/v1575962666/WifiFastSpot/color-aws.svg`)', alt='AWS')
        span AWS
      .bubble.bubble-four
        img(:src='(`https://res.cloudinary.com/sekuritim/image/upload/v1575962666/WifiFastSpot/color-docker.svg`)', alt='Docker')
        span Docker
      .bubble.bubble-five
        img(:src='(`https://res.cloudinary.com/sekuritim/image/upload/v1575962666/WifiFastSpot/color-linux.svg`)', alt='Linux')
        span Linux
      .bubble.bubble-six
        img(:src='(`https://res.cloudinary.com/sekuritim/image/upload/v1575962666/WifiFastSpot/color-git.svg`)', alt='Git')
        span Git
      .bubble.bubble-seven
        img(:src='(`https://res.cloudinary.com/sekuritim/image/upload/v1575965823/WifiFastSpot/MongoDB_Logo_FullColorBlack_RGB.png`)', alt='Mongo DB')
      .bubble.bubble-eight
        img(:src='(`https://res.cloudinary.com/sekuritim/image/upload/v1575978671/WifiFastSpot/Kubernetesss.png`)', alt='Kubernetes')
      .bubble.bubble-nine
        img(:src='require(`../assets/logos/elasticsearch.svg`)', alt='Elasticsearch')
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'

library.add(fab, fas)

export default {
  name: 'HomeIntegrations',
  data () {
    return {}
  }
}
</script>

<style lang='scss'>
.home-integrations {
  background: var(--v-greyish-lighten4);
  text-align: center;
  padding: 100px 0;

  @media screen and (max-width: 599px) {
    padding: 50px 0;
  }

  h2 {
    font-size: 30px;
    font-weight: 600;
    padding: 0 15px;
    line-height: 30px;

    @media screen and (max-width: 599px) {
      font-size: 25px;
    }
  }
  h3 {
    font-size: 16px;
    font-weight: 300;
    padding: 15px;
    color: var(--v-greyish-darken1);
  }

  &-radar {
    width: 1200px;
    height: 1200px;
    margin: 50px auto 0;
    position: relative;

    .circle {
      border-radius: 50%;
      border: 1px solid var(--v-greyish-lighten2);
      width: 400px;
      height: 400px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    @for $i from 1 through 5 {
      .circle:nth-child(#{$i}) {
        width: 200px + $i * 200px;
        height: 200px + $i * 200px;
      }
    }

    .bubble {
      border-radius: 50%;
      width: 150px;
      height: 150px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background-color: #FFF;
      border: 1px solid var(--v-greyish-lighten2);
      box-shadow: 0 30px 60px 0 rgba(0,11,40,.1);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      user-select: none;

      img {
        width: 50px;
      }

      span {
        color: var(--v-greyish-darken1);
        margin-top: 7px;
      }

      &-one {
        // background-image: linear-gradient(40deg,#6754e2,#19cce6);
        width: 200px;
        height: 200px;

        img {
          margin-top: 7px;
          width: calc(100% - 30px);
        }
      }

      &-two {
        width: 150px;
        height: 150px;
        top: 9%;
        left: 57%;
        img {
          margin-top: 7px;
          width: calc(100% - 15px);
        }
      }

      &-three {
        top: 25%;
        left: 7%;
      }

      &-four {
        top: 40%;
        left: 72%;
      }

      &-five {
        top: 64%;
        left: 98%;
      }

      &-six {
        top: 75%;
        left: 17%;
      }

      &-seven {
        top: 91%;
        left: 60%;
        img {
          margin-top: 7px;
          width: calc(100% - 15px);
        }
      }

      &-eight {
        top: 36%;
        left: 30%;
        width: 115px;
        height: 115px;
        img {
          margin-top: 10px;
          width: calc(100% - 38px);
        }
      }

      &-nine {
        top: 73%;
        left: 40%;
        width: 80px;
        height: 80px;

        img {
          width: 100%;
        }
      }

      &-ten {
        top: 73%;
        left: 74%;
        width: 90px;
        height: 90px;
      }
    }

    @media screen and (max-width: 1350px) {
      width: 900px;
      height: 900px;

      @for $i from 1 through 5 {
        .circle:nth-child(#{$i}) {
          width: 150px + $i * 150px;
          height: 150px + $i * 150px;
        }
      }
    }

    @media screen and (max-width: 1025px) {
      width: 600px;
      height: 600px;

      @for $i from 1 through 5 {
        .circle:nth-child(#{$i}) {
          width: 100px + $i * 100px;
          height: 100px + $i * 100px;
        }
      }

      .bubble {
        width: 100px;
        height: 100px;

        img {
          width: 40px;
        }

        span {
          font-size: 12px;
          margin-top: 2px;
        }

        &-one {
          width: 120px;
          height: 120px;

          img {
            margin-top: 7px;
            width: calc(100% - 30px);
          }
        }

        &-eight {
          width: 200px;
          height: 200px;
          img {
            width: 100%;
          }
        }

        &-nine {
          width: 60px;
          height: 60px;

          img {
            width: 100%;
          }
        }

        &-ten {
          width: 50px;
          height: 50px;
        }
      }
    }

    @media screen and (max-width: 699px) {
      width: 375px;
      height: 375px;
      margin: 15px auto 0;

      @for $i from 1 through 5 {
        .circle:nth-child(#{$i}) {
          width: 60px + $i * 60px;
          height: 60px + $i * 60px;
        }
      }

      .bubble {
        width: 50px;
        height: 50px;

        img {
          width: 30px;
        }

        span {
          display: none;
        }

        &-one {
          width: 120px;
          height: 120px;

          img {
            margin-top: 7px;
            width: calc(100% - 30px);
          }
        }

        &-three {
          left: 10%;
        }

        &-four {
          left: 75%;
          top: 30%;
        }

        &-five {
          left: 92%;
          top: 52%;
        }

        &-seven {
          top: 98%;
        }

        &-nine {
          img {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
